/*
 * Copyright 2020 Digi Dinos JSC. All rights reserved.
 * Email: tech@digidinos.com.
 */

import Vue from 'vue'

import {
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  ConfigProvider,
  Dropdown,
  FormModel,
  Icon,
  Input,
  Layout,
  Menu,
  Modal,
  Radio,
  Result,
  Row,
  Select,
  Spin,
  Table,
  Tree,
  Drawer,
  Pagination,
  notification,
  Upload,
  Empty
} from 'ant-design-vue'

Vue.use(Button)
Vue.use(Upload)
Vue.use(Card)
Vue.use(Checkbox)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(ConfigProvider)
Vue.use(DatePicker)
Vue.use(Drawer)
Vue.use(Dropdown)
Vue.use(FormModel)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Layout)
Vue.use(Menu)
Vue.use(Modal)
Vue.use(Pagination)
Vue.use(Radio)
Vue.use(Result)
Vue.use(Row)
Vue.use(Select)
Vue.use(Spin)
Vue.use(Table)
Vue.use(Tree)
Vue.use(Empty)

Vue.prototype.$notification = notification
Vue.prototype.$confirm = Modal.confirm
